import React from 'react'
import { shieldIcn } from '../../../images/TeleBindingImages/TeleBindingImages'

const IfscDetails = ({micr, bankName, branchName}) => {
  return (
    <>
          <div className="fetchedDetailsWrapper">
              <div className="fetchedDetail">
                  <div className="fetchedDetailHeading">
                      <span className="shieldIconWrapper">
                          <img src={shieldIcn} alt="shieldIcon" className="shieldIcon" />
                      </span>
                      <p>Fetched Details</p>
                  </div>

                  <div className="fetchedDetailContent">
                      <div className="fetchedDetailItem">
                          <p>MICR Number</p>
                          <span>{micr}</span>
                      </div>
                      <div className="fetchedDetailItem">
                          <p>Bank Name</p>
                          <span>{bankName}</span>
                      </div>
                      <div className="fetchedDetailItem">
                          <p>Branch Name</p>
                          <span>{branchName}</span>
                      </div>
                  </div>
              </div>
          </div>
    </>
  )
}

export default IfscDetails